import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConnectionStatusEnum } from '../../globals-enums/connection-status.enum';
import { GlobalsService } from '../../globals-services/globals.service';
import { ConnectivityActionDialogComponent } from '../connectivity-action-dialog/connectivity-action-dialog.component';

@Component({
  selector: 'app-connectivity',
  templateUrl: './connectivity.component.html',
  styleUrls: ['./connectivity.component.css']
})
export class ConnectivityComponent implements OnInit {
  supplierList: any[] = [];
  noConnectedSuppliers: any[] = [];
  selectedBrand: any;
  suggestedBrandList: any = []
  selectedSupplierList: any = []
  brandList: any = []
  selectedBrandName: String;
  isLoading: boolean = false;
  showSuccessMessage: boolean = false;
  resendConnSuccessMessage: boolean = false;
  disconnectConSuccessMessage: boolean = false;
  ConnectionStatusEnum = ConnectionStatusEnum
  constructor(
    private http: HttpClient,
    private globalsService: GlobalsService,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.getSupplierWithConnectedBrand()
    this.getAllBrands();

  }
  getSupplierWithConnectedBrand() {
    this.isLoading = true
    this.http.get<any[]>(this.globalsService.baseHref + '/shared/getMySuppliersWithBrandConnect').subscribe((suppliers) => {
      this.supplierList = suppliers;
      this.supplierList.sort(function (a, b) {
        const x = a['name'];
        const y = b['name'];
        return x > y ? 1 : x < y ? -1 : 0;
      })
      setTimeout(
        () => {
          this.isLoading = false;
        }, 2000
      );
    }, (err) => { });
  }
  getAllBrands() {
    this.isLoading = true;
    this.http.get<any[]>(this.globalsService.baseHref + '/shared/getAllBrands').subscribe((response) => {
      this.brandList = response;
      setTimeout(
        () => {
          this.isLoading = false;
        }, 2000
      );
    },
      (err) => {
        console.log(err)
      });
  }


  onTabChanged(index) {
    switch (index) {
      case 0:
        this.getSupplierWithConnectedBrand()
        break;
      case 1:
        this.selectedBrand = null;
        this.selectedBrandName = "";
        this.noConnectedSuppliers = [];
        this.getAllBrands();
    }
  }
  searchBrand(searchText: String) {
    console.log(searchText)

    if (searchText.length > 0) {
      this.selectedBrandName = searchText
      this.suggestedBrandList = this.brandList.filter(res => {
        return res.name.toLowerCase().match(this.selectedBrandName.toLocaleLowerCase());
      }
      );
      console.log(this.suggestedBrandList)
    }
  }

  onSearchBrandSelect(element) {
    this.isLoading = true;
    let brand = this.suggestedBrandList.find(brand => brand.name == element.name);
    this.selectedBrand = brand;
    setTimeout(
      () => {
        this.isLoading = false;
      }, 2000
    );
    if (brand != null) {
      this.getSupplierByBrandId()
    }
  }
  getSupplierByBrandId() {
    this.http.get<any[]>(this.globalsService.baseHref + '/shared/getMySuppliersWithoutBrandConnect/' + this.selectedBrand.id).subscribe((response) => {

      this.noConnectedSuppliers = response;

    },
      (err) => {
        console.log(err)
      });
  }
  sendConnectionInvitation() {
    let data = {
      brand: this.selectedBrand,
      suppliers: this.selectedSupplierList
    }
    this.isLoading = true;
    this.http.post(this.globalsService.baseHref + '/shared/thirdPartyConnInvite', data).subscribe((response) => {
      if (response) {
        this.showSuccessMessage = true;
        this.getSupplierByBrandId()

        setTimeout(
          () => {
            this.showSuccessMessage = false;

            this.isLoading = false;
          }, 4000
        );
      }
    },
      (err) => {
        console.log(err)
      });
  }

  onSupplierSelected(supplier, isChecked: boolean) {
    if (isChecked) {
      this.selectedSupplierList.push(supplier);
    } else {

      this.selectedSupplierList.splice(this.selectedSupplierList.indexOf(supplier), 1);


    }

    console.info(this.selectedSupplierList)

  }
  selectAll(event) {

    if (event.target.checked) {

      this.noConnectedSuppliers.forEach(item => {
        item.checked = true
        let isSelected = this.selectedSupplierList.find((el) => item.id === el.id);
        if (!isSelected) {

          this.selectedSupplierList.push(item);
        }
      }
      )
    } else {

      this.noConnectedSuppliers.forEach(item => {
        item.checked = false

        this.selectedSupplierList.splice(this.selectedSupplierList.indexOf(item), 1);
      }
      )


    }
    console.info(this.selectedSupplierList)
  }
  openDisconnectDialog(connection, supplierOrganizationName) {
    console.log(connection)

    const dialogRef = this.dialog.open(ConnectivityActionDialogComponent, {
      width: '500px',
      height: '200px',
      data: {
        title: supplierOrganizationName,
        type: 1,
        connection: connection,
        supplierOrganizationName:supplierOrganizationName,
        brandName: connection.brandName
      }
    });

    dialogRef.afterClosed().subscribe(response => {
      let connectionId = response.data.connection.id
      this.disconnectConnection(connectionId);

      this.dialog.closeAll();



    });
  }
  openResendInvitationDialog(connection, supplierOrganizationName) {
    const dialogRef = this.dialog.open(ConnectivityActionDialogComponent, {
      width: '500px',
      height: '200px',
      data: {
        title:supplierOrganizationName,
        type: 2,
        connection: connection,
        supplierOrganizationName:supplierOrganizationName,
        brandName: connection.brandName
       }
    });

    dialogRef.afterClosed().subscribe(response => {
      let connectionId = response.data.connection.id
      this.resendConnectionInvitation(connectionId)
      this.dialog.closeAll();
    });
  }

  disconnectConnection(connectionId) {
    let data = {
      id: connectionId

    }
    this.isLoading = true;
    this.http.post(this.globalsService.baseHref + '/shared/thirdPartyDisconnect', data).subscribe((response) => {
      if (response) {
        this.disconnectConSuccessMessage = true;
        this.getSupplierWithConnectedBrand()
        setTimeout(
          () => {
            this.isLoading = false;
            this.disconnectConSuccessMessage = false;
          }, 2000
        );
      }
    },
      (err) => {
        console.log(err)
      });
  }
  resendConnectionInvitation(id) {
    let data = {
      id: id,

    }
    this.isLoading = true;
    this.http.post(this.globalsService.baseHref + '/shared/resendInvite', data).subscribe((response) => {
      if (response) {
        this.resendConnSuccessMessage = true;
        this.getSupplierWithConnectedBrand()
        setTimeout(
          () => {
            this.isLoading = false;
            this.resendConnSuccessMessage = false;
          }, 2000
        );
      }
    },
      (err) => {
        console.log(err)
      });
  }
}
